var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons"},_vm._l((_vm.items),function(item){return _c('div',{key:item.label,staticClass:"common",class:{selected: _vm.currentName === item.en },on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }